<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>App版本设置</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchClick" btnCode='009P00AB001' v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="addBtnClick" btnCode='009P00AB002' v-if="btnFlg[1]">新增</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="version" label="版本号" align="center"></el-table-column>
        <el-table-column prop="size" label="大小" align="center"></el-table-column>
        <el-table-column prop="appName" label="App名称" align="center"></el-table-column>
        <el-table-column prop="groupFlag" label="App所属" align="center"></el-table-column>
        <el-table-column prop="flag" label="是否强制更新" align="center" >
          <template slot-scope="scope"><div>
            <el-button type="text" v-if="scope.row.flag == '1'" @click="yesOrNoChage(scope.row)">是</el-button>
            <el-button type="text" v-else @click="yesOrNoChage(scope.row)">否</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="createTime" label="上传时间" align="center" width="200">
           <template slot-scope="scope"><div>
            <span>{{scope.row.createTime | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="downloadClick(scope.row)" type="text" size="small" btnCode='009P00AB003' v-if="btnFlg[2]">下载</el-button>
            <el-button @click="delRowClick(scope.row)" type="text" size="small" btnCode='009P00AB004' v-if="btnFlg[3]">删除</el-button>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="addCloseDialog('addFrom')"
    :visible.sync="addMack"
    width="550px"
    center>
      <div style="width:70%; margin:15px auto;" v-loading="addLoading">
        <span>
          <el-form  :model="addFrom" :rules="rules" ref="addFrom" class="demo-form-inline" label-width="110px" size="mini">
            <el-form-item label="版本号:" prop="buildNumber">
              <el-input  placeholder="请选择文件自动填充版本号" disabled maxlength="100"  v-model="addFrom.buildNumber" style="width:190px;"></el-input>
            </el-form-item>
            <el-form-item label="是否强制更新:" prop="yesOrNo" style="margin-top:20px;">
              <el-radio v-model="addFrom.yesOrNo" label="1">是</el-radio>
              <el-radio v-model="addFrom.yesOrNo" label="0">否</el-radio>
            </el-form-item>
            <el-form-item label="App名称:" prop="appName" style="margin-top:20px;">
              <el-input  placeholder="请选择文件自动填充App名称" disabled maxlength="100"  v-model="addFrom.appName" style="width:190px;"></el-input>
            </el-form-item>
            <el-form-item label="App所属:" prop="groupDropDown" style="margin-top:20px;">
              <el-select v-model="addFrom.groupDropDown" placeholder="请选择">
                <el-option
                  v-for="(item,index) in groupDropDownData"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传文件:" prop="file" style="margin-top:20px;">
              <div style="display: flex;">
                <input
                type="file"
                ref="file"
                accept=".apk"
                @change="fileSelect($event)"/>
                <i class="el-icon-delete" @click="delClick" style="margin:5px 0 0 5px;" v-if="file.length!=0"></i>
              </div>
            </el-form-item>
          </el-form>
        </span>
        <div style="margin:30px auto;width:130px;">
          <el-button type="primary" size='mini' @click="finish('addFrom')">保存</el-button>
          <el-button @click="closeClick('addFrom')" size='mini'>关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 是否强制更新修改 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeMack"
    width="550px"
    center>
      <div style="width:70%; margin:15px auto;" v-loading="changeLoading">
        <span>
          <el-form  :model="changeFrom" ref="changeFrom" class="demo-form-inline" label-width="110px" size="mini">
            <el-form-item label="是否强制更新:" prop="yesOrNo" style="margin-top:20px;">
              <el-radio v-model="changeFrom.yesOrNo" label="1">是</el-radio>
              <el-radio v-model="changeFrom.yesOrNo" label="0">否</el-radio>
            </el-form-item>
          </el-form>
        </span>
        <div style="margin:30px auto;width:130px;">
          <el-button type="primary" size='mini' @click="changefinish('changeFrom')">保存</el-button>
          <el-button @click="changecloseClick('changeFrom')" size='mini'>关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  appInfoList, // 列表
  upload, // 添加
  groupDropDownBox, // App所属系统
  updateAppInfo, // 修改是否强制更新
  deleteAppInfo // 删除
} from '@/api/common'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { fileDownAll } from '@/utils/fileDownAll.js'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  inject: ['reload'],
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['009P00AB001', '009P00AB002', '009P00AB003', '009P00AB004'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10
      },
      tableList: [],
      // 添加
      addMack: false,
      addFrom: {
        yesOrNo: '0',
        buildNumber: '',
        appName: '',
        groupDropDown: ''
      },
      groupDropDownData: [],
      percent: 0,
      addLoading: false,
      tabLoading: false,
      file: [],
      rules: {
        buildNumber: [
          { required: true, message: '请选择文件自动填充版本号', trigger: 'blur' }
        ],
        yesOrNo: [
          { required: true, message: '请选择是否强制更新', trigger: 'blur' }
        ],
        groupDropDown: [
          { required: true, message: '请选择App所属', trigger: 'change' }
        ]
      },
      showDel: false,
      changeMack: false,
      changeLoading: false,
      changeFrom: {
        yesOrNo: ''
      },
      rowId: ''
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/uploadApk')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 100) + 'px'
  },
  methods: {
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      appInfoList(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        DonMessage.error(err.message)
      })
    },
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    getGroupDropDownBox () {
      groupDropDownBox().then(res => {
        this.groupDropDownData = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 点击添加按钮
    addBtnClick () {
      this.addMack = true
      this.title = '上传信息'
      this.file = []
      this.showDel = this.$refs.file
      this.getGroupDropDownBox()
      console.log(this.file, 'this.files')
    },
    // 选择文件
    fileSelect (e) {
      this.file = e.target.files[0]
      console.log(this.file, 'e')
      if (this.file) {
        this.getMsg()
      }
    },
    // 删除
    delClick () {
      this.file = []
      this.$refs.file.value = null
      this.addFrom.buildNumber = ''
      this.addFrom.appName = ''
    },
    // 解析安装包
    getMsg () {
      const AppInfoParser = require('app-info-parser')
      const parser = new AppInfoParser(this.file).parse().then(result => {
        let fileName = this.file.name
        let suffix = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
        if (result) {
          console.log(result, 'suffix')
          this.icon = result.icon
          if (suffix == 'apk') {
            this.addFrom.appName = result.application.label[0]
            this.apppackage = result.package
            this.appversion = result.versionCode
            this.addFrom.buildNumber = result.versionName
          }
          // this.isShow = true
          console.log(this.addFrom.appName, 'this.addFrom.appName')
        }
      })
    },
    // 点击上传确定
    finish (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          imgfile.append('file', this.file)
          imgfile.append('version', this.addFrom.buildNumber)
          imgfile.append('flag', this.addFrom.yesOrNo)
          imgfile.append('appName', this.addFrom.appName)
          imgfile.append('groupFlag', this.addFrom.groupDropDown)
          this.addJK(imgfile)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    addJK (data) {
      this.addLoading = true
      upload(data).then(res => {
        this.addLoading = false
        this.addMack = false
        this.$message.success('添加成功')
        this.reload()
        this.getSeatchData(this.searchFrom)
      }).catch(error => {
        this.addLoading = false
        this.$message.error(error.message)
      })
    },
    // 点击关闭
    closeClick (formName) {
      this.$refs[formName].resetFields()
      this.addMack = false
      // this.reload()
      this.file = []
      this.$refs.file.value = null
    },
    addCloseDialog (formName) {
      this.$refs[formName].resetFields()
      // this.reload()
    },
    downloadClick (row) {
      this.$confirm('是否确定下载？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        fileDownAll(
          this.global.signature + `/app/info/download/${row.id}`,
          {},
          row.appName + '',
          '.apk'
        )
      }).catch(() => {
      })
    },
    // 是否强制更新修改
    yesOrNoChage (row) {
      this.title = '修改'
      this.changeMack = true
      this.$set(this.changeFrom, 'yesOrNo', row.flag)
      this.rowId = row.id
    },
    changefinish (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          updateAppInfo({
            id: this.rowId, // 主键id,
            flag: this.changeFrom.yesOrNo // 是否强制更新
          }).then(res => {
            this.changeLoading = false
            this.changeMack = false
            this.$message.success('修改成功')
            this.getSeatchData(this.searchFrom)
          }).catch(err => {
            this.changeLoading = false
            DonMessage.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 点击关闭
    changecloseClick (formName) {
      this.$refs[formName].resetFields()
      this.changeMack = false
    },
    // 删除
    delRowClick (row) {
      this.$confirm('是否确定删除？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deleteAppInfo(row.id).then(res => {
          this.$message.success('删除成功')
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;

}
.inpBox{
  margin: 10px 0 0 -30px;
}
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
</style>
